import HttpRequestService from "./HttpRequestService";

const PurchaseService = {};

//API for get all data
PurchaseService.subscribePlan = function (orgId, planId) {
  return HttpRequestService.post(`purchase?orgId=${orgId}&planId=${planId}`);
};


export default PurchaseService;
